import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { RouterModule } from "@angular/router";
import { FuseSidebarModule } from "@fuse/components";
import { FuseWidgetModule } from "@fuse/components/widget/widget.module";
import { FuseSharedModule } from "@fuse/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { BreadcrumbsComponent } from "app/helper-components/breadcrumbs/breadcrumbs.component";
import { SharedModule } from "app/helper-components/Shared.module";
import { SubnavComponent } from "app/layout/components/subnav/subnav.component";
import { PinViewComponent } from "app/main/pin-view/pin-view.component";
import { SurveyAvailableDialogComponent } from "app/main/survey/survey-available-dialog/survey-available-dialog.component";

@NgModule({
  declarations: [
    SubnavComponent,
    PinViewComponent,
    BreadcrumbsComponent,
    SurveyAvailableDialogComponent,
  ],
  imports: [
    RouterModule,

    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    MatTableModule,
    MatTabsModule,
    MatIconModule,
    NgxChartsModule,
    MatFormFieldModule,
    MatInputModule,

    FuseSharedModule,
    FuseSidebarModule,
    FuseWidgetModule,
    TranslateModule,
    SharedModule,
  ],
  exports: [
    SubnavComponent,
    PinViewComponent,
    BreadcrumbsComponent,
    SurveyAvailableDialogComponent,
  ],
})
export class SubnavModule {}
